var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-filter-checkbox__holder" }, [
    _c(
      "div",
      {
        class: [
          "theme-filter-checkbox",
          {
            "theme-filter-checkbox--column-direction": _vm.columnDirection,
            "theme-filter-checkbox--limited": _vm.limited && !_vm.showLimited
          }
        ]
      },
      [
        Object.keys(_vm.options).length
          ? _vm._l(_vm.options, function(option, key) {
              return _c(
                "label",
                { key: key, class: ["theme-filter-checkbox__item"] },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.model,
                        expression: "model"
                      }
                    ],
                    attrs: {
                      name: _vm.name,
                      type: "checkbox",
                      id: _vm.name + "-" + key
                    },
                    domProps: {
                      value: key,
                      checked: Array.isArray(_vm.model)
                        ? _vm._i(_vm.model, key) > -1
                        : _vm.model
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.model,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = key,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.model = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.model = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.model = $$c
                          }
                        },
                        function($event) {
                          return _vm.stateChange(_vm.model)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "theme-filter-checkbox__indicator"
                  }),
                  _vm._v(" "),
                  option
                    ? [
                        _c("span", {
                          staticClass: "theme-filter-checkbox__item-label",
                          domProps: { innerHTML: _vm._s(option) }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            })
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.limited
      ? _c("div", { staticClass: "theme-filter-checkbox__show-more" }, [
          _c(
            "a",
            {
              staticClass: "theme-btn theme-btn--text",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.showLimited = !_vm.showLimited
                }
              }
            },
            [
              _vm.showLimited
                ? [
                    _vm._v("\n        Show less\n        "),
                    _c("i", { staticClass: "icon-thin-up" })
                  ]
                : [
                    _vm._v("\n        Show more\n        "),
                    _c("i", { staticClass: "icon-thin-down" })
                  ]
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3ec5a52", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3ec5a52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeFilterCheckboxes.vue
// module id = 595
// module chunks = 1